module.exports = __webpack_public_path__ + "img/exams_and_vaccines.8aa991ab.svg";